export const formOrderMapper = (fd) => {
  const location = fd?.location;

  const payload = {
    customerId: fd?.customerId,
    location,
    overShippingAllowed: fd?.overShipping,
    shipVia: fd?.shipVia,
    shipTo: fd?.shipTo,
    freight: fd?.freight,
    isVendor: fd?.isVendor,
    ...(fd?.type && { orderTypeId: fd?.type }),
    ...(fd?.poNumber && { poNumber: fd?.poNumber }),
  };
  return payload;
};
